import React, { useState } from 'react';
import axios from 'axios';
import './BalanceForm.css'; // Import the CSS file for styling

const BalanceForm = ({ onNewData, darkTheme }) => {
  const [formData, setFormData] = useState({
    amount: '',
    description: '',
    transaction_kind: 'income',
    due_date: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Envia os dados para a API com o cabeçalho de autorização
      const response = await axios.post('https://coinflowapi-706a77649549.herokuapp.com/api/v1/balances', formData, {
        headers: {
          Authorization: '4X2pKb5SWhC0fz3H5h8udkg59npyEmbe88xNoN5yE60utCAVeW5'
        }
      });
      console.log('Novo balance criado:', response.data);

      // Atualiza os dados no gráfico se a prop onNewData for fornecida
      if (onNewData) onNewData(response.data);

      // Limpa o formulário após o envio
      setFormData({
        amount: '',
        description: '',
        transaction_kind: 'income',
        due_date: '',
      });
    } catch (error) {
      console.error('Erro ao criar balance:', error);
      alert('Erro ao criar balance. Verifique os dados e tente novamente.');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`balance-form ${darkTheme ? 'dark' : 'light'}`}
    >
      <h2 className="form-title">
        Inserir Novo Balance
      </h2>
      <div className="form-group">
        <label className="form-label">Valor:</label>
        <input
          type="number"
          name="amount"
          value={formData.amount}
          onChange={handleChange}
          required
          className="form-input"
        />
      </div>
      <div className="form-group">
        <label className="form-label">
          Descrição:
        </label>
        <input
          type="text"
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
          className="form-input"
        />
      </div>
      <div className="form-group">
        <label className="form-label">
          Tipo de Transação:
        </label>
        <select
          name="transaction_kind"
          value={formData.transaction_kind}
          onChange={handleChange}
          required
          className="form-input"
        >
          <option value="income">Receita</option>
          <option value="expense">Despesa</option>
          <option value="debt">Dívida</option>
        </select>
      </div>
      <div className="form-group">
        <label className="form-label">Data:</label>
        <input
          type="date"
          name="due_date"
          value={formData.due_date}
          onChange={handleChange}
          required
          className="form-input"
        />
      </div>
      <button
        type="submit"
        className="form-button"
      >
        Adicionar
      </button>
    </form>
  );
};

export default BalanceForm;
